import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Col, Container, Image, Modal, Row } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import "./loginslider.css";
import "./PartnerCTA.css";
import BumppyEppLogo from "../Images/Logos/Bumppy-epp-logo.svg";
import chAafoLogo from "../Images/Logos/chAafo-logo.svg";
import GrownPayLogo from "../Images/Logos/Grown-Pe.svg";
import GTKLogo from "../Images/Logos/GTK Logo.svg";
import PakkyLogo from "../Images/Logos/Packky.svg";
import ShubPaisaLogo from "../Images/Logos/Shubh-Paisa-Logo.svg";
import TopAdvocacy from "../Images/Logos/Top-Advocacy.svg";
import TrawloLogo from "../Images/Logos/Trawlo-Yellow-Green.svg";
import Anlook from "../Images/Logos/Anlook.svg";
import BillPunch from "../Images/Logos/BillPuLogo.svg";
import UkoPayLogo from "../Images/Logos/UKOPAYLogo.svg";
import { FaArrowRight } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa";
const Partners = () => {
  const [show, setShow] = useState(false);


  return (
    <>
      <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
        {/* home */}

        <div>
          <Nav />
        </div>
        <div className="row  mx-md-0 mx-3 ">
          <div className="col-md-1 "></div>
          <div className="col-md-10 col-12 m-0 p-0">
            <div className="p-5 text-center">
              <LogoSlider />
              <div className="partner-cta-container text-center position-relative overflow-hidden">
                {/* Decorative Wave SVG */}
                <svg
                  className="wave-svg"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 1440 320"
                >
                  <path
                    fill="#B2B0E8"
                    fillOpacity="1"
                    d="M0,224L60,192C120,160,240,96,360,74.7C480,53,600,75,720,106.7C840,139,960,181,1080,176C1200,171,1320,117,1380,90.7L1440,64V0H0Z"
                  ></path>
                </svg>

                {/* Content */}
                <div className="content-box fade-up">
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/744/744502.png"
                    alt="Partnership Icon"
                    className="floating-icon mb-3"
                  />
                  <h2 className="mb-3 fw-bold" style={{ color: "#ff6b6b" }}>
                    Ready to Partner with Us?
                  </h2>

                  <p className="text-muted fs-5 mb-4">
                    Join hands with us and grow your business with powerful
                    collaborations.
                  </p>
                  <Button
                    variant="primary"
                    size="lg"
                    className="px-4 py-2 rounded-pill shadow-sm scale-btn"
                    onClick={() => setShow(true)}
                  >
                    Become a Partner
                  </Button>
                </div>

                {/* Modal */}
                <PartnerModal show={show} handleClose={() => setShow(false)} />
              </div>

              <Testimonials />
            </div>
          </div>
          <div className="col-md-1"></div>
        </div>

        <div
          className="m-0 p-0"
          style={{
            overflow: "hidden",
            background:
              "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",

            borderTopRightRadius: "2rem",
            borderTopLeftRadius: "2rem",
          }}
        >
          <Footer />
        </div>
      </Container>
    </>
  );
};
const logos = [
  { src: Anlook, alt: "Anlook" },
  { src: BumppyEppLogo, alt: "Bumppy EPP" },
  { src: GrownPayLogo, alt: "Grown Pay" },
  { src: BillPunch, alt: "Bill Punch" },
  { src: chAafoLogo, alt: "chAafo" },
  { src: GTKLogo, alt: "GTK" },
  { src: PakkyLogo, alt: "Pakky" },
  { src: ShubPaisaLogo, alt: "Shub Paisa" },
  { src: TopAdvocacy, alt: "Top Advocacy" },
  { src: TrawloLogo, alt: "Trawlo" },
  { src: UkoPayLogo, alt: "UKO Pay" },
];
const LogoSlider = () => {
  return (
    <div className="scroll-wrapper mb-5">
      <h2
        className="text-center"
        style={{
          fontSize: "2.5rem",
          fontWeight: "700",
          background: "linear-gradient(90deg, #ff0080, #7928ca, #2afadf)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          letterSpacing: "1px",
        }}
      >
        Our Trusted Partners 💫
      </h2>
      <p
        className="m-3 text-center"
        style={{
          color: "#555",
          fontSize: "1.5rem",
        }}
      >
        We proudly collaborate with leading organizations to create impactful
        solutions.
      </p>
      <div
        style={{
          height: "4px",
          width: "70%",
          margin: "0 auto 2rem auto",
          background: "linear-gradient(90deg, #ff0080, #7928ca, #2afadf)",
          borderRadius: "2px",
        }}
      ></div>

      <div className="scroll-content mt-3">
        {[...logos, ...logos].map((logo, index) => (
          <Image
            key={index}
            className="logo-img"
            src={logo.src}
            alt={logo.alt}
            // style={imageStyle}
            style={{
              width: "200px",
              margin: "0 40px",
              objectFit: "contain",
            }}
          />
        ))}
      </div>
    </div>
  );
};
const Testimonials = () => {
  const [testimonials, setTestimonials] = useState();
  const testinomialRef = useRef(null);
  const scrollByCard = (ref, direction) => {
    if (!ref.current) return;
    const card = ref.current.querySelector("div");
    if (!card) return;
    const cardWidth = card.offsetWidth + 40;
    ref.current.scrollBy({ left: direction * cardWidth, behavior: "smooth" });
  };
  useEffect(() => {
    setTestimonials([
      {
        img: "https://ui-avatars.com/api/?name=Nakul+Arora&background=0D8ABC&color=fff&size=128",
        category: "Category",
        content:
          "Seobix has been a strategic game changer for us at Getzkick. As Head of Media Strategy, I’m constantly looking to align our digital visibility with audience engagement and Seobix delivered beyond expectations.",
        author: "Nakul Arora",
        designation: "Head of Media Strategy, Getzkick",
        review: "★★★★★",
      },
      {
        img: "https://ui-avatars.com/api/?name=Rakesh+Khatri&background=F39C12&color=fff&size=128",
        category: "Category",
        content:
          "Seobix has completely elevated our digital performance at GrownPe. As the Head of Business Development, my priority is creating scalable, impactful outreach and Seobix delivered results that felt tailor made for our journey.",
        author: "Rakesh Khatri",
        designation: "Head of Business Development, GrownPe",
        review: "★★★★★",
      },
      {
        img: "https://ui-avatars.com/api/?name=Raj+Singhania&background=27AE60&color=fff&size=128",
        category: "Category",
        content:
          "Seobix has been a real game changer for us at Anlook. In operations, I focus on making things run smoothly and efficiently and I needed a marketing partner who could do the same for our digital presence. Seobix stepped in and completely transformed the way we show up online.",
        author: "Raj Singhania",
        designation: "Operations Manager, Anlook",
        review: "★★★★★",
      },
      {
        img: "https://ui-avatars.com/api/?name=Himanshu+Singh&background=8E44AD&color=fff&size=128",
        category: "Category",
        content:
          "Collaborating with Seobix has been a transformative experience for BillPunch. As Product Director, I’m deeply invested in ensuring our platform is not just optimized for efficiency but also reaches the right audience. Seobix took this vision and turned it into reality.",
        author: "Himanshu Singh",
        designation: "Product Director, BillPunch",
        review: "★★★★★",
      },
      {
        img: "https://ui-avatars.com/api/?name=Pankaj+Sharma&background=E74C3C&color=fff&size=128",
        category: "Category",
        content:
          "Working with Seobix has truly elevated our marketing game at Bumppy. As the Marketing Head, my goal is to not only drive traffic but to ensure that every visitor is engaged and converts into meaningful business. Seobix delivered on that promise and more.",
        author: "Pankaj Sharma",
        designation: "Marketing Head, Bumppy",
        review: "★★★★★",
      },
      {
        img: "https://ui-avatars.com/api/?name=Mohit+Bisht&background=2C3E50&color=fff&size=128",
        category: "Category",
        content:
          "Seobix has been instrumental in transforming our digital reach at Packky. As the Head of Sales, I’m always focused on delivering meaningful leads and measurable growth and Seobix delivered beyond expectations. Their customized SEO strategy not only improved our organic rankings but also elevated our brand visibility bringing more qualified leads to our sales team.",
        author: "Mohit Bisht",
        designation: "Head of Sales, Packky",
        review: "★★★★★",
      },
      {
        img: "https://ui-avatars.com/api/?name=Abhishek+Gupta&background=34495E&color=fff&size=128",
        category: "Category",
        content:
          "Partnering with Seobix has truly transformed our digital marketing efforts at Trawlo. As the Marketing Manager, I was seeking more than just visibility, I needed meaningful online growth that led to real conversions.",
        author: "Abhishek Gupta",
        designation: "Marketing Manager, Trawlo",
        review: "★★★★★",
      },
      {
        img: "https://ui-avatars.com/api/?name=Sumit+Mishra&background=FF5733&color=fff&size=128",
        category: "Category",
        content:
          "Working in the legal field, accuracy and trust are non negotiable. When we partnered with Seobix, I was looking for a team that could help Top Advocacy stand out online without compromising on professionalism.",
        author: "Sumit Mishra",
        designation: "Senior Legal Advisor, Top Advocacy",
        review: "★★★★★",
      },
    ]);
  }, []);
  return (
    <div>
      <h2
        style={{
          fontSize: "2.2rem",
          fontWeight: "700",
          fontFamily: "'Poppins', sans-serif",
          textAlign: "center",
          color: "#003366",
          position: "relative",
        }}
      >
        Testimonials
        <span
          style={{
            display: "block",
            width: "80px",
            height: "4px",
            background: "#FC4100",
            margin: "0.5rem auto 0",
            borderRadius: "2px",
          }}
        />
      </h2>

      <div className="row mt-3">
        <div className="col d-flex justify-content-end">
          <button
            onClick={() => scrollByCard(testinomialRef, -1)}
            className="btn btn-outline-primary rounded-circle me-2"
          >
            <FaArrowLeft />
          </button>
          <button
            onClick={() => scrollByCard(testinomialRef, 1)}
            className="btn btn-outline-primary rounded-circle"
          >
            <FaArrowRight />
          </button>
        </div>
      </div>
      <div className="col-12 ">
        <SliderSectionLsNews
          title="latest News"
          images={testimonials}
          containerRef={testinomialRef}
        />
      </div>
    </div>
  );
};
function SliderSectionLsNews({ images, containerRef }) {
  return (
    <div className="mt-4">
      <div
        className="d-flex"
        style={{
          overflowX: "auto",
          scrollbarWidth: "none",
          gap: "40px",
          padding: "10px 0",
        }}
        ref={containerRef}
      >
        {(images ?? []).map((item, index) => (
          <div
            className="mt-5 mb-3 ms-4"
            key={index}
            style={{
              flex: "0 0 auto",
              width: "400px",
              background: "#fff",
              borderRadius: "20px",
              position: "relative",
              padding: "2rem 1.5rem 1.5rem",
              boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "-20px",
                left: "-20px",
                background: "#ccc",
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "20px",
                fontWeight: "bold",
              }}
            >
              “
            </div>

            <div
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "50%",
                overflow: "hidden",
                margin: "0 auto",
                marginTop: "-70px",
                border: "5px solid #fff",
                boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
              }}
            >
              <img
                src={item.img}
                alt={item.author}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>

            <div className="text-center mt-3">
              <p
                style={{
                  fontSize: "0.95rem",
                  color: "#333",
                  lineHeight: "1.5",
                  height: "8em",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: 4,
                  WebkitBoxOrient: "vertical",
                }}
              >
                {item.content}
              </p>

              <div style={{ marginTop: "1rem" }}>
                <h6 style={{ margin: 0, fontWeight: "bold" }}>{item.author}</h6>
                <p style={{ fontSize: "0.8rem", color: "#666", margin: 0 }}>
                  {item.designation}
                </p>

                <div
                  className="mt-2"
                  style={{ color: "#007bff", fontSize: "1rem" }}
                >
                  {item.review}
                </div>
              </div>
            </div>

            <div
              style={{
                position: "absolute",
                bottom: "-20px",
                right: "-20px",
                background: "#999",
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "20px",
                fontWeight: "bold",
              }}
            >
              ”
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
const PartnerModal = ({ show, handleClose }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    workEmail: "",
    jobTitle: "",
    phoneNumber: "",
    country: "",
    company: "",
    revenue: "",
    industry: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="fw-bold">Become Our Partner</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted">
          Fill in your details and our team will reach out to discuss
          partnership opportunities.
        </p>
        <form onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Col>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                className="form-control rounded-pill"
                placeholder="First Name*"
              />
            </Col>
            <Col>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                className="form-control rounded-pill"
                placeholder="Last Name*"
              />
            </Col>
          </Row>
          <div className="mb-3">
            <input
              type="email"
              name="workEmail"
              value={formData.workEmail}
              onChange={handleChange}
              className="form-control rounded-pill"
              placeholder="Work Email*"
            />
          </div>
          <Row className="mb-3">
            <Col>
              <input
                type="text"
                name="jobTitle"
                value={formData.jobTitle}
                onChange={handleChange}
                className="form-control rounded-pill"
                placeholder="Job Title*"
              />
            </Col>
            <Col>
              <input
                type="tel"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                className="form-control rounded-pill"
                placeholder="Phone Number (Optional)"
              />
            </Col>
          </Row>
          <div className="mb-3">
            <select
              name="country"
              value={formData.country}
              onChange={handleChange}
              className="form-control rounded-pill"
            >
              <option value="">Select Country of Residence*</option>
              <option>India</option>
              <option>USA</option>
              <option>UK</option>
            </select>
          </div>
          <Row className="mb-3">
            <Col>
              <input
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
                className="form-control rounded-pill"
                placeholder="Company*"
              />
            </Col>
            <Col>
              <select
                name="revenue"
                value={formData.revenue}
                onChange={handleChange}
                className="form-control rounded-pill"
              >
                <option value="">Company Revenue*</option>
                <option>Less than $1M</option>
                <option>$1M - $10M</option>
                <option>$10M+</option>
              </select>
            </Col>
          </Row>
          <div className="mb-3">
            <select
              name="industry"
              value={formData.industry}
              onChange={handleChange}
              className="form-control rounded-pill"
            >
              <option value="">Select Industry*</option>
              <option>Technology</option>
              <option>Finance</option>
              <option>Healthcare</option>
            </select>
          </div>
          <div className="mb-3">
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="form-control"
              placeholder="How can we help?"
              rows="3"
            ></textarea>
          </div>

          <Modal.Footer>
            <Button variant="light" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Modal.Footer>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default Partners;
